import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheck,
  faClose,
  faEye,
  faHome,
  faPlug,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { API_URL_ENDPOINT } from "../appsetting";
import CustomPagination from "../components/CustomPagination";
import { useNavigate } from "react-router-dom";
import { Routess } from "../Routes/routes";
import { useApi, useHasPermission } from "../helpers/useApi";
import OffCanvas from "../components/OffCanvas";
import { Accordion } from "react-bootstrap";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import Permissions from "../Routes/permissions";

export const KycSections = () => {
  const callApi = useApi();
  const navigate = useNavigate();
  const hasPermission = useHasPermission();
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const [showModel, setShowModel] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState({});
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    getData();
    getDocs();
  }, []);

  const getData = async (cp = null) => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.KYC + "/section-doc");
      if (response.status) {
        setData(response.data);
      }
    } catch {
      setData({});
    } finally {
      setDataLoading(false);
    }
  };

  const getDocs = async () => {
    try {
      setDataLoading(true);
      const filters = [];
      filters.push(`IsActive:${true}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${1}`,
        `pageSize=${100}`,
        `orderBy=`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.KYC + "/docs" + `?${queryParams}`
      );
      if (response.status) {
        setDocs(response.data?.items);
      }
    } catch {
      setDocs([]);
    } finally {
      setDataLoading(false);
    }
  };

  const submitForm = async (data) => {
    if (data == null) return;
    console.log("data", data);
    // return;
    try {
      const response = await callApi(
        `${API_URL_ENDPOINT.KYC}/section-doc/${data.sectionType}/${data.document}`,
        {
          method: "POST",
          data: null,
        }
      );
      if (response.status) {
        setShowModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const removeDoc = async (id) => {
    try {
      const response = await callApi(
        `${API_URL_ENDPOINT.KYC}/section-doc/${id}`,
        {
          method: "DELETE",
          data: null,
        }
      );
      if (response.status) {
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };
  return (
    <>
      <Model show={showModel} size={"md"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Document</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(submitForm)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="Section Type"
                    name={"sectionType"}
                    validationRules={{ required: "Section Type is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""} selected>
                      Select Option
                    </option>
                    <option value={"Address"}>Address</option>
                    <option value={"Identity"}>Identity</option>
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="Section Document"
                    name={"document"}
                    validationRules={{ required: "Section Type is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value="" selected>
                      Select Document
                    </option>
                    {docs?.length > 0 &&
                      docs.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.documentTitle}
                        </option>
                      ))}
                  </SelectBox>
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button type="submit" disabled={isSubmitting} variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between d-flex flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item>NPSP</Breadcrumb.Item> */}
            <Breadcrumb.Item active>KYC Section Documents</Breadcrumb.Item>
          </Breadcrumb>
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">KYC Section Documents</h4>
          </div>
        </div>
        <div className="d-flex align-items-center">
          {hasPermission(Permissions.KYC.SectionManage) && (
            <Button
              onClick={() => setShowModel(true)}
              className="me-2 d-block"
              variant="primary"
              style={{ whiteSpace: "nowrap" }}
            >
              <FontAwesomeIcon icon={faPlus} /> Add New Document
            </Button>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="">
              {dataLoading ? (
                <div className="text-center my-3">
                  <span
                    className="spinner-border text-primary"
                    role="status"
                  ></span>
                </div>
              ) : (
                <>
                  <h6>Address Documents</h6>
                  <Table
                    responsive
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0 text-center">#</th>
                        <th className="border-0 text-center">Document Name</th>
                        <th className="border-0 text-end pe-4">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.Address?.length > 0 ? (
                        data?.Address.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center align-middle">
                              {index + 1}
                            </td>

                            <td className="fw-bold align-middle text-center">
                              {item.documentTitle || "-"}
                            </td>

                            <td className="text-end align-middle">
                              {hasPermission(Permissions.KYC.SectionManage) && (
                                <Button
                                  className="btn-sm btn-danger"
                                  onClick={() =>
                                    confirmDeleteToast(() => removeDoc(item.id))
                                  }
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-6">
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="">
              {dataLoading ? (
                <div className="text-center my-3">
                  <span
                    className="spinner-border text-primary"
                    role="status"
                  ></span>
                </div>
              ) : (
                <>
                  <h6>Identity Documents</h6>
                  <Table
                    responsive
                    className="table-centered table-nowrap rounded mb-0"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-0 text-center">#</th>
                        <th className="border-0 text-center">Document Name</th>
                        <th className="border-0 text-end pe-4">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.Identity?.length > 0 ? (
                        data?.Identity.map((item, index) => (
                          <tr key={index}>
                            <td className="text-center align-middle">
                              {index + 1}
                            </td>

                            <td className="fw-bold align-middle text-center">
                              {item.documentTitle || "-"}
                            </td>

                            <td className="text-end align-middle">
                              {hasPermission(Permissions.KYC.SectionManage) && (
                                <Button
                                  className="btn-sm btn-danger"
                                  onClick={() =>
                                    confirmDeleteToast(() => removeDoc(item.id))
                                  }
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};
